module.exports = __webpack_public_path__ + "static/media/heien.a03265a3.png";